import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import objectAssign from 'object-assign';
import { ValidMe, isStringEmpty } from 'businessLogic/validation.js';
import { updateOrgUnitSupportContact, changeOrgUnitSupportContact } from '../../../../actions/organisation.js';

export default function CenterPanelUpdate(props) {
  const dispatch = useDispatch();
  const [activeElementName, setActiveElementName] = useState(null);
  const [moreAssistanceMessageCharsLeft, setMoreAssistanceMessageCharsLeft] = useState(
    200 - props.updatedOrgUnitSupportContactForm.moreAssistance.substr(0, 200).length
  );
  const [maxChars, setMaxChars] = useState(200);

  // In order to avoid input field lose focus when placeholder is changed
  const getFocusedInputFieldName = () => {
    setActiveElementName(document.activeElement.name);
  };

  useEffect(() => {
    let isFormEmpty =
      isStringEmpty(props.updatedOrgUnitSupportContactForm.organisaionSupportName) &&
      isStringEmpty(props.updatedOrgUnitSupportContactForm.organisaionSupportEmail) &&
      isStringEmpty(props.updatedOrgUnitSupportContactForm.organisaionSupportPhone) &&
      isStringEmpty(props.updatedOrgUnitSupportContactForm.organisaionSupportWebsite);

    if (
      isFormEmpty == false &&
      ['supportName', 'supportEmail', 'supportPhone', 'supportWebsite'].includes(activeElementName) >= 0
    ) {
      let callback = () => {
        const inputActiveElement = document.querySelectorAll(`input[name=${activeElementName}]`);
        if (inputActiveElement.length > 0) {
          inputActiveElement[0].focus();
        }
      };
      setTimeout(callback, 50);
      setActiveElementName(null);
    }
  }, [props.updatedOrgUnitSupportContactForm]);

  const changeInputField = (value, entryName) => {
    let updatedSupportContactForm = {};
    switch (entryName) {
      case 'supportName':
        updatedSupportContactForm = {
          ...props.updatedOrgUnitSupportContactForm,
          organisaionSupportName: value,
        };
        break;
      case 'supportEmail':
        updatedSupportContactForm = {
          ...props.updatedOrgUnitSupportContactForm,
          organisaionSupportEmail: value,
        };
        break;
      case 'supportPhone':
        updatedSupportContactForm = {
          ...props.updatedOrgUnitSupportContactForm,
          organisaionSupportPhone: value,
        };
        break;
      case 'supportWebsite':
        updatedSupportContactForm = {
          ...props.updatedOrgUnitSupportContactForm,
          organisaionSupportWebsite: value,
        };
        break;
    }
    dispatch(changeOrgUnitSupportContact(updatedSupportContactForm));
  };

  const changeMoreAssistanceInfo = (value) => {
    value = value.substr(0, 200);
    setMoreAssistanceMessageCharsLeft(maxChars - value.length);
    let updatedSupportContactForm = {
      ...props.updatedOrgUnitSupportContactForm,
      moreAssistance: value,
    };
    dispatch(changeOrgUnitSupportContact(updatedSupportContactForm));
  };

  const formWithoutValidation = (
    <div>
      <div className="bold title-sms">{APP.LANGUAGE.SupportContactModal.SupportInfoForProviders}</div>
      <div className="placeholder-label no-bold div-like color-placeholder mrtxs">
        {APP.LANGUAGE.SupportContactModal.SupportNameEdit}
      </div>
      <Txt
        tabIndex="1"
        name="supportName"
        notRenderPlaceholderAsTitle={true}
        titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportNameEdit}
        onKeyPress={getFocusedInputFieldName}
        onChange={(value) => changeInputField(value, 'supportName')}
        placeholder={`${props.updatedOrgUnitSupportContactForm.organisaionSupportName || 'Not provided'} (default)`}
        value=""
        noTitle
      />
      <div className="placeholder-label no-bold div-like color-placeholder mrtxs">
        {APP.LANGUAGE.SupportContactModal.SupportEmailEdit}
      </div>
      <Txt
        tabIndex="2"
        name="supportEmail"
        notRenderPlaceholderAsTitle={true}
        titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportEmailEdit}
        onKeyPress={getFocusedInputFieldName}
        onChange={(value) => changeInputField(value, 'supportEmail')}
        placeholder={`${props.updatedOrgUnitSupportContactForm.organisaionSupportEmail || 'Not provided'} (default)`}
        value=""
        noTitle
      />
      <div className="placeholder-label no-bold div-like color-placeholder mrtxs">
        {APP.LANGUAGE.SupportContactModal.SupportTelEdit}
      </div>
      <Txt
        tabIndex="3"
        name="supportPhone"
        notRenderPlaceholderAsTitle={true}
        titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportTelEdit}
        onKeyPress={getFocusedInputFieldName}
        onChange={(value) => changeInputField(value, 'supportPhone')}
        placeholder={`${props.updatedOrgUnitSupportContactForm.organisaionSupportPhone || 'Not provided'} (default)`}
        value=""
        noTitle
      />
      <div className="placeholder-label no-bold div-like color-placeholder mrtxs">
        {APP.LANGUAGE.SupportContactModal.SupportWebsiteEdit}
      </div>
      <Txt
        tabIndex="4"
        name="supportWebsite"
        notRenderPlaceholderAsTitle={true}
        titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportWebsiteEdit}
        onKeyPress={getFocusedInputFieldName}
        onChange={(value) => changeInputField(value, 'supportWebsite')}
        placeholder={`${props.updatedOrgUnitSupportContactForm.organisaionSupportWebsite || 'Not provided'} (default)`}
        value=""
        noTitle
      />
    </div>
  );
  const formWithValidation = (
    <div>
      <div className="bold title-sms">{APP.LANGUAGE.SupportContactModal.SupportInfoForProviders}</div>
      <ValidMe validmefor="required" group="orgSupportContactModal">
        <Txt
          tabIndex="1"
          name="supportName"
          focusme={!!!activeElementName}
          notRenderPlaceholderAsTitle={false}
          titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportNameEdit}
          onKeyPress={getFocusedInputFieldName}
          onChange={(value) => changeInputField(value, 'supportName')}
          placeholder={APP.LANGUAGE.OrgUnitSupportContact.SupportNameEdit}
          value={props.updatedOrgUnitSupportContactForm.organisaionSupportName}
          noTitle
        />
      </ValidMe>
      <ValidMe validmefor="email" group="orgSupportContactModal">
        <Txt
          tabIndex="2"
          name="supportEmail"
          notRenderPlaceholderAsTitle={false}
          titlePlaceholder={APP.LANGUAGE.OrgUnitSupportContact.SupportEmailEdit}
          onKeyPress={getFocusedInputFieldName}
          onChange={(value) => changeInputField(value, 'supportEmail')}
          placeholder={APP.LANGUAGE.OrgUnitSupportContact.SupportEmailEdit}
          value={props.updatedOrgUnitSupportContactForm.organisaionSupportEmail}
          noTitle
        />
      </ValidMe>
      <ValidMe validmefor="phoneNumber@emptyok&possibleNumber" group="orgSupportContactModal">
        <Txt
          tabIndex="3"
          name="supportPhone"
          notRenderPlaceholderAsTitle={false}
          titlePlaceholder={APP.LANGUAGE.OrgUnitSupportContact.SupportTelEdit}
          onKeyPress={getFocusedInputFieldName}
          onChange={(value) => changeInputField(value, 'supportPhone')}
          placeholder={APP.LANGUAGE.OrgUnitSupportContact.SupportTelEdit}
          value={props.updatedOrgUnitSupportContactForm.organisaionSupportPhone}
          noTitle
        />
      </ValidMe>
      <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="orgSupportContactModal">
        <Txt
          tabIndex="4"
          name="supportWebsite"
          notRenderPlaceholderAsTitle={false}
          titlePlaceholder={APP.LANGUAGE.OrgUnitSupportContact.SupportWebsiteEdit}
          onKeyPress={getFocusedInputFieldName}
          onChange={(value) => changeInputField(value, 'supportWebsite')}
          placeholder={APP.LANGUAGE.OrgUnitSupportContact.SupportWebsiteEdit}
          value={props.updatedOrgUnitSupportContactForm.organisaionSupportWebsite}
          noTitle
        />
      </ValidMe>
    </div>
  );
  const validationForm = formWithValidation;
  return (
    <div className="ui form mrbxl">
      {validationForm}
      <div className="bold title-sms mrtl">{APP.LANGUAGE.OrgUnitSupportContact.SupportInfoForCallers}</div>
      <div className="mrtxs">
        <Txt
          tabIndex="5"
          name="orgLevelCallerMoreAssist"
          customOnChange={true}
          textareaLabelRelativeRenderOnTop
          noTitle
          notRenderPlaceholderAsTitle={true}
          titlePlaceholder={APP.LANGUAGE.OrgUnitSupportContact.MoreAssistInfo}
          placeholder={APP.LANGUAGE.OrgUnitSupportContact.MoreAssistInfo}
          value={props.updatedOrgUnitSupportContactForm.moreAssistance}
          onChange={changeMoreAssistanceInfo}
        />
        <div className="wa-charsRight small-font-size mrbs">
          <span>{APP.LANGUAGE.OrgUnitSupportContact.CharactersRemaining + moreAssistanceMessageCharsLeft}</span>
        </div>
      </div>
    </div>
  );
}
